// extracted by mini-css-extract-plugin
export default {"info":"Info_info__2n3jv","dark":"Info_dark__+-tx0","info-wrapper":"Info_info-wrapper__sJxCN","before-msg":"Info_before-msg__3vMKC"};